// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  speed: 2000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 6000, // スライダー表示時間
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
});

const gallerySwiper = new Swiper(".js_top_gallery_swiper", {
  effect: 'fade',
  loop: true,
  slidesPerView: 2,
  speed: 6000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
  breakpoints: {
    1000: {
      slidesPerView: 3,
    },
  },
});
